import { useEffect, useMemo, useState } from "react";
import { buildMediaQuery, MediaQueryConfig } from "utils/styles";

const useMediaQuery = ({
  minWidth,
  maxWidth,
  minAspectRatio,
  maxAspectRatio,
}: MediaQueryConfig): boolean => {
  const mediaQuery = useMemo(
    () =>
      buildMediaQuery({ minWidth, maxWidth, minAspectRatio, maxAspectRatio }),
    [maxAspectRatio, maxWidth, minAspectRatio, minWidth]
  );

  const mediaQueryList = useMemo(
    () => window.matchMedia(mediaQuery),
    [mediaQuery]
  );

  const [matches, setMatches] = useState(mediaQueryList.matches);

  useEffect(() => {
    const mediaQueryHandler = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };

    // Use deprecated methods only for compatibility with IE11
    if (!mediaQueryList.addEventListener) {
      mediaQueryList.addListener(mediaQueryHandler);
    } else {
      mediaQueryList.addEventListener("change", mediaQueryHandler);
    }

    return () => {
      if (!mediaQueryList.removeEventListener) {
        mediaQueryList.removeListener(mediaQueryHandler);
      } else {
        mediaQueryList.removeEventListener("change", mediaQueryHandler);
      }
    };
  }, [mediaQueryList]);

  return matches;
};

export default useMediaQuery;
